import React from 'react';
import { SimpleCardTemplate } from './SimpleCardTemplate';
import { ModernSplitTemplate } from './ModernSplitTemplate';
import { useCheckoutStore } from '../../store/checkoutStore';

interface PreviewSettings {
  heading: string;
  features: string[];
  buttonText: string;
  primaryColor: string;
  logo?: string;
}

interface Props {
  settings: PreviewSettings;
}

export const CheckoutPreview = ({ settings }: Props) => {
  const { currentPage } = useCheckoutStore();
  const templateId = currentPage?.templateId || 'modern-split';

  return templateId === 'simple-card' ? (
    <SimpleCardTemplate settings={settings} />
  ) : (
    <ModernSplitTemplate settings={settings} />
  );
};